import Api from "./Api";

class Ads {
  async fetchAds(bikeId, position) {
    return await Api.get(`/campaign/bike/${position}/${bikeId}`).then((response) => {
      return response?.data?.response?.data || null;
    });
  }
}
// eslint-disable-next-line
export default new Ads();
